import {
    ADD_THANK_YOU,
    EDIT_THANK_YOU,
    LIST_THANK_YOU,
    VIEW_THANK_YOU,
    DELETE_THANK_YOU,

    THANK_YOU_SUCCESS,
    THANK_YOU_ERROR,
  
  } from "./actionTypes"
  
  // add THANK_YOU
  export const addThankYou = (data, history, callback) => {
    return {
      type: ADD_THANK_YOU,
      payload: { data, history, callback }
    }
  }
  
  // edit THANK_YOU
  export const editThankYou = (data, id, callback) => {
    return {
      type: EDIT_THANK_YOU,
      payload: { data, id, callback },
    }
  }
  
  // list THANK_YOU
  export const listThankYou = (data, callback) => {
    return {
      type: LIST_THANK_YOU,
      payload: { data, callback },
    }
  }
  
  // view THANK_YOU
  export const viewThankYou = (data, history) => {
    return {
      type: VIEW_THANK_YOU,
      payload: { data, history },
    }
  }
  
  // delete THANK_YOU
  export const deleteThankYou = (data, callback) => {
    return {
      type: DELETE_THANK_YOU,
      payload: { data, callback },
    }
  }
  
  
  export const thankYouSuccess = message => {
    return {
      type: THANK_YOU_SUCCESS,
      payload: message,
    }
  }
  
  export const thankYouError = message => {
    return {
      type: THANK_YOU_ERROR,
      payload: message,
    }
  }
  